<div class="home-wrap">
  <app-main-navbar></app-main-navbar>

  <section class="hero">
    <div class="modules">
      <button class="module-card" (click)="openIdeaGeneration()">
        <img src="/assets/idea_generation_icon.svg" class="module-icon" alt="">
        <h5 class="module-title">Technology Trends</h5>
        <p class="module-text">Find trending themes among the innovation landscape and high-potential investment opportunities.</p>
      </button>

      <button class="module-card" (click)="openCompanySearch()">
        <img src="/assets/company_search_icon.svg" class="module-icon" alt="">
        <h5 class="module-title">Company Insights</h5>
        <p class="module-text">Evaluate the innovative strength of companies of interest and benchmark them against competition.</p>
      </button>

      <button class="module-card" (click)="openThematicSearch()">
        <img src="/assets/thematic_search_icon.svg" class="module-icon" alt="">
        <h5 class="module-title">Thematic Search</h5>
        <p class="module-text">Search for technology-based investment themes and find innovation leaders in each area.</p>
      </button>

      <button class="module-card" (click)="openMonitoring()">
        <img src="/assets/monitoring.svg" class="module-icon" alt="">
        <h5 class="module-title">Monitoring &amp; Watchlists</h5>
        <p class="module-text">Set up watchlists and monitor companies in your investment universe.</p>
      </button>
    </div>
  </section>

  <section class="highlights" *ngIf="hasHighlights">
    <div class="highlights-inner">
      <div class="highlights-header">
        <div>
          <h2 class="highlights-title">Quant IP Dashboard</h2>
          <p class="highlights-sub">
            Innovation highlights from our latest data update<ng-container *ngIf="dataDate">,
            <span class="asof" >through {{ dataDate | date: 'd MMMM yyyy' }}</span></ng-container>.
          </p>
        </div>
        <div class="seg">
          <button *ngFor="let s of scopes"
                  type="button"
                  class="seg-btn"
                  [class.active]="scope === s.key"
                  (click)="selectScope(s.key)">
            {{ s.label }}
          </button>
        </div>
      </div>

      <div class="hl-split">
        <div class="panel panel-up">
          <div class="panel-head">
            <span class="panel-icon">&#9650;</span>
            <span class="panel-title">Rising Innovators<span class="panel-sub">biggest 3-month innovation score gains, all rated Buy</span></span>
          </div>
          <div class="row row-head">
            <span class="name-cell">Company &amp; peer group</span>
            <span class="sig-move" *ngIf="scope==='public'" title="Quant IP signal 3 months ago, and today">
              <span class="sig-col">3 mo ago</span>
              <span class="sig-arrow"></span>
              <span class="sig-col">now</span>
            </span>
            <span class="score-cell" title="Innovation score (0-100) within its peer group">Innovation score</span>
            <span class="delta" title="Change in innovation score vs 3 months ago">Innovation score change</span>
            <span class="row-chev"></span>
          </div>
          <button class="row" *ngFor="let h of top" (click)="openCompany(h)">
            <span class="name-cell">
              <span class="row-name" [title]="h.entity_name">{{ h.entity_name || h.entityid }}</span>
              <span class="row-sub" *ngIf="h.bucket" [title]="h.bucket">{{ h.bucket }}</span>
            </span>
            <span class="sig-move" *ngIf="scope==='public'">
              <ng-container *ngIf="h.signal_previous && h.signal_previous !== h.signal; else heldUp">
                <span class="sig-pill" [ngClass]="'pill-' + h.signal_previous">{{ h.signal_previous }}</span>
                <span class="sig-arrow">&rarr;</span>
                <span class="sig-pill" [ngClass]="'pill-' + h.signal">{{ h.signal }}</span>
              </ng-container>
              <ng-template #heldUp>
                <span class="sig-pill sig-held" [ngClass]="'pill-' + h.signal">
                  {{ h.signal }}{{ h.signal_previous ? ' held' : '' }}
                </span>
              </ng-template>
            </span>
            <span class="score-cell">
              <span class="score-bar"><i [style.width.%]="h.innovation_score"
                                         [style.background]="barColor(h.innovation_score)"></i></span>
              <span class="score-num" [ngClass]="'sig-' + h.signal">{{ h.innovation_score }}</span>
            </span>
            <span class="delta up">&#9650;&nbsp;+{{ h.score_change }}</span>
            <span class="row-chev">&rsaquo;</span>
          </button>
          <p class="row-empty" *ngIf="!top.length">No qualifying gainers this month.</p>
        </div>

        <div class="panel panel-down">
          <div class="panel-head">
            <span class="panel-icon">&#9660;</span>
            <span class="panel-title">Falling Innovators<span class="panel-sub">biggest 3-month innovation score drops, all lost a signal grade</span></span>
          </div>
          <div class="row row-head">
            <span class="name-cell">Company &amp; peer group</span>
            <span class="sig-move" *ngIf="scope==='public'" title="Quant IP signal 3 months ago, and today">
              <span class="sig-col">3 mo ago</span>
              <span class="sig-arrow"></span>
              <span class="sig-col">now</span>
            </span>
            <span class="score-cell" title="Innovation score (0-100) within its peer group">Innovation score</span>
            <span class="delta" title="Change in innovation score vs 3 months ago">Innovation score change</span>
            <span class="row-chev"></span>
          </div>
          <button class="row" *ngFor="let h of flop" (click)="openCompany(h)">
            <span class="name-cell">
              <span class="row-name" [title]="h.entity_name">{{ h.entity_name || h.entityid }}</span>
              <span class="row-sub" *ngIf="h.bucket" [title]="h.bucket">{{ h.bucket }}</span>
            </span>
            <span class="sig-move" *ngIf="scope==='public'">
              <ng-container *ngIf="h.signal_previous && h.signal_previous !== h.signal; else heldDown">
                <span class="sig-pill" [ngClass]="'pill-' + h.signal_previous">{{ h.signal_previous }}</span>
                <span class="sig-arrow">&rarr;</span>
                <span class="sig-pill" [ngClass]="'pill-' + h.signal">{{ h.signal }}</span>
              </ng-container>
              <ng-template #heldDown>
                <span class="sig-pill sig-held" [ngClass]="'pill-' + h.signal">
                  {{ h.signal }}{{ h.signal_previous ? ' held' : '' }}
                </span>
              </ng-template>
            </span>
            <span class="score-cell">
              <span class="score-bar"><i [style.width.%]="h.innovation_score"
                                         [style.background]="barColor(h.innovation_score)"></i></span>
              <span class="score-num" [ngClass]="'sig-' + h.signal">{{ h.innovation_score }}</span>
            </span>
            <span class="delta down" [style.color]="flagColor(h.score_bracket ?? 3)">
              <img class="hl-flag" [src]="flagImage(h.score_bracket ?? 3)" alt="">{{ h.score_change }}
            </span>
            <span class="row-chev">&rsaquo;</span>
          </button>
          <p class="row-empty" *ngIf="!flop.length">No qualifying decliners this month.</p>
        </div>
      </div>

      <h3 class="sub-title">Peer Group Leaders <span>highest innovation score in each peer group</span></h3>
      <div class="hl-grid">
        <button class="hl-card" *ngFor="let h of leaderCards"
                [ngClass]="'top-' + h.signal"
                (click)="openCompany(h)">
          <span class="hl-tag" [title]="h.bucket || ''">{{ h.bucket }}</span>
          <div class="hl-name" [title]="h.entity_name">{{ h.entity_name || h.entityid }}</div>
          <div class="hl-metrics">
            <span class="hl-score" [ngClass]="'sig-' + h.signal">{{ h.innovation_score }}</span>
            <span class="hl-delta" *ngIf="h.score_change !== null"
                  [class.up]="h.score_change! >= 0" [class.down]="h.score_change! < 0">
              {{ h.score_change! >= 0 ? '▲' : '▼' }}&nbsp;{{ h.score_change! >= 0 ? '+' : '' }}{{ h.score_change }}
            </span>
          </div>
        </button>
      </div>

      <div class="view-all-wrap" *ngIf="restLeaders.length">
        <button type="button" class="view-all" (click)="expanded = !expanded">
          {{ expanded ? 'Show less ▴' : 'View ' + restLeaders.length + ' more ▾' }}
        </button>
      </div>

      <div class="leaders-table-wrap" *ngIf="expanded">
        <table class="leaders-table">
          <thead>
            <tr>
              <th>Peer Group</th>
              <th>Leader</th>
              <th class="num">Innovation score</th>
              <th class="num">Innovation score change, 3 mo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let h of restLeaders" (click)="openCompany(h)" title="Open company">
              <td>{{ h.bucket }}</td>
              <td>{{ h.entity_name || h.entityid }}</td>
              <td class="num" [ngClass]="'sig-' + h.signal">{{ h.innovation_score }}</td>
              <td class="num">
                <span class="hl-delta" *ngIf="h.score_change !== null"
                      [class.up]="h.score_change! >= 0" [class.down]="h.score_change! < 0">
                  {{ h.score_change! >= 0 ? '▲' : '▼' }}&nbsp;{{ h.score_change! >= 0 ? '+' : '' }}{{ h.score_change }}
                </span>
                <span *ngIf="h.score_change === null" class="hl-na">—</span>
              </td>
              <td class="open-cell">›</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sub-header" *ngIf="hasThemes">
        <h3 class="sub-title" title="Across listed companies only">Technology Trends</h3>
        <button type="button" class="view-all" (click)="openIdeaGeneration()">View all technologies &rsaquo;</button>
      </div>

      <div class="hl-split" *ngIf="hasThemes">
        <div class="panel panel-up">
          <div class="panel-head">
            <span class="panel-icon">&#9650;</span>
            <span class="panel-title">Accelerating<span class="panel-sub">fastest growing technologies</span></span>
          </div>
          <div class="row row-head">
            <span class="row-name">Technology</span>
            <span class="row-stage">Lifecycle</span>
            <span class="row-growth" title="Growth in inventions vs the prior 12 months">Growth 12m</span>
            <span class="row-count" title="Inventions published in the last 12 months">Inventions</span>
            <span class="row-chev"></span>
          </div>
          <button class="row" *ngFor="let t of themes.top_clusters" (click)="openTheme(t)">
            <span class="row-name" [title]="t.cluster_name">{{ t.cluster_name }}</span>
            <span class="row-stage" [style.color]="stageColor(t.stage)"
                  [style.background]="stageBgColor(t.stage)">{{ t.stage }}</span>
            <span class="row-growth up">+{{ t.relative_growth | number: '1.0-1' }}%</span>
            <span class="row-count">{{ t.invention_count_12m | number: '1.0-0' }}<i>inv.</i></span>
            <span class="row-chev">&rsaquo;</span>
          </button>
        </div>

        <div class="panel panel-down">
          <div class="panel-head">
            <span class="panel-icon">&#9660;</span>
            <span class="panel-title">Declining<span class="panel-sub">largest technologies past their peak</span></span>
          </div>
          <div class="row row-head">
            <span class="row-name">Technology</span>
            <span class="row-stage">Lifecycle</span>
            <span class="row-growth" title="Growth in inventions vs the prior 12 months">Growth 12m</span>
            <span class="row-count" title="Inventions published in the last 12 months">Inventions</span>
            <span class="row-chev"></span>
          </div>
          <button class="row" *ngFor="let t of themes.flop_clusters" (click)="openTheme(t)">
            <span class="row-name" [title]="t.cluster_name">{{ t.cluster_name }}</span>
            <span class="row-stage" [style.color]="stageColor(t.stage)"
                  [style.background]="stageBgColor(t.stage)">{{ t.stage }}</span>
            <span class="row-growth" [class.up]="t.relative_growth >= 0" [class.down]="t.relative_growth < 0">
              {{ t.relative_growth >= 0 ? '+' : '' }}{{ t.relative_growth | number: '1.0-1' }}%
            </span>
            <span class="row-count">{{ t.invention_count_12m | number: '1.0-0' }}<i>inv.</i></span>
            <span class="row-chev">&rsaquo;</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
